import React from 'react';
import PropTypes from 'prop-types';

import './buff.css';

const Buff = (props) => {
  return (
    <div className='buff'>
      {props.text}
    </div>
  );
}

Buff.props = {
  text: PropTypes.string.isRequired
};

export default Buff;